import $ from 'jQuery';


export default function() {

  $(function() {
    initialize_filters_accordions();
    resizeListener();
  });


  function initialize_filters_accordions() {
    const $filterAccItems = $('.filters-accordion');
    const $filterAccItemToggles = $('.filters-accordion__toggle', $filterAccItems);

    if ($filterAccItemToggles.length) {

      // Bind mouse click / keyboard space/enter button activation.
      // ---
      $filterAccItemToggles.off('click').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const $thisToggle = $(this);

        if ($thisToggle.attr('aria-expanded') === 'true') {
          closeFilterAccordion($thisToggle);
        }
        else {
          openFilterAccordion($thisToggle);
        }
      });
    }
  }


  // Work functions invoked by event binds.
  // ---

  function closeFilterAccordion($filterAccItemToggle) {
    const $parentItem = $filterAccItemToggle.closest('.filters-accordion');
    const $itemPanel = $parentItem.find('.filters-accordion__panel').first();

    $parentItem.removeClass('filters-accordion--open');
    $filterAccItemToggle.attr('aria-expanded', 'false');

    /*
      Use jquery slide collapse to hide, this is still the most
      reliable slide/expand option we have readily available.
      Also, it handles inline display: none/block at the end of its
      animation. - JE
    */
    $itemPanel.slideUp(250); // inline display: none; after 250ms.
    $itemPanel.prop('hidden', true);
  }


  function openFilterAccordion($filterAccItemToggle) {
    const $parentItem = $filterAccItemToggle.closest('.filters-accordion');
    const $itemPanel = $parentItem.find('.filters-accordion__panel').first();

    $parentItem.addClass('filters-accordion--open');
    $filterAccItemToggle.attr('aria-expanded', 'true');

    $itemPanel.prop('hidden', false);
    $itemPanel.slideDown(250); // inline display: block; after 250ms.
  }


  function checkViewport() {
    const viewportWidth = $(window).innerWidth();
    const $filterAccItems = $('.filters-accordion');
    const $filterAccItemToggles = $('.filters-accordion__toggle', $filterAccItems);
    const $filterAccPanels = $('.filters-accordion__panel', $filterAccItems);

    $filterAccItems.removeClass('filters-accordion--open');
    $filterAccItemToggles.attr('aria-expanded', 'false');

    if (viewportWidth > 1100) {
      // reset large display.

      $filterAccPanels
        .prop('hidden', false)
        .show(0);
    }
    else {
      // reset small display.
      $filterAccPanels
        .prop('hidden', true)
        .hide(0);
    }
  }



  // ---
  // Resize Listener
  // ---
  // On window resize (with debounce) update anything that might
  // change and need updating.
  function resizeListener() {
    let resizeTimeout;

    window.addEventListener('resize', () => {
      // If there's a timer, cancel it
      if (resizeTimeout) {
        window.cancelAnimationFrame(resizeTimeout);
      }

      // Setup the new requestAnimationFrame()
      // this asks the browser's rendering system to fit us
      // in when it has a microsecond moment breather.
      //
      // This is effectively a "debounce" timed so it will collide with
      // reflow and animation less.
      resizeTimeout = window.requestAnimationFrame(() => {
        checkViewport();
      });
    }, false);
  }
}
